module.exports = __webpack_public_path__ + "static/media/simulation-select-time-icon.6ac79be3.svg";